// Props for MUI <Tabs> that keep every tab reachable on a phone: the row scrolls sideways instead of being cut off,
// and is centred again once it fits. Spread them and pass the rest of the styling through `tabsSx`.
export const scrollableTabsProps = {
  variant: "scrollable",
  scrollButtons: "auto", // arrows only where a mouse needs them; on a phone you swipe, and a cut-off label shows there is more
};

export const tabsSx = (extra = {}) => ({
  "& .MuiTabs-flexContainer": { justifyContent: { xs: "flex-start", md: "center" } },
  ...extra,
});

// Keeps a table's first columns (car number, driver) in view while the rest scrolls sideways on a phone.
// Cells need an opaque background to hide what scrolls underneath; `odd` repeats the rows' zebra stripe.
// Use as `sx={[{ ...own styles }, stickyOnPhone(0)]}`; the second column's `left` is the first one's width.
export const PHONE_NUMBER_COLUMN = 44;

export const stickyOnPhone = (left, { header = false, odd = false } = {}) => (theme) => ({
  [theme.breakpoints.down("sm")]: {
    position: "sticky",
    left,
    zIndex: header ? 3 : 2,
    backgroundColor: header
      ? (theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[200])
      : theme.palette.background.default,
    ...(odd && !header
      ? { backgroundImage: `linear-gradient(${theme.palette.action.hover}, ${theme.palette.action.hover})` }
      : {}),
  },
});

// The narrow car-number column on a phone
export const phoneNumberColumn = (theme) => ({
  [theme.breakpoints.down("sm")]: {
    width: PHONE_NUMBER_COLUMN,
    minWidth: PHONE_NUMBER_COLUMN,
    maxWidth: PHONE_NUMBER_COLUMN,
    px: 1,
  },
});
